import { useVariable } from './useVariable';
import { useCallback } from 'react';
import { useInput } from './useInput';
export var useInOutWithInput = function useInOutWithInput(value, defaultValue, onIn, onOut) {
  var onInHandler = useVariable(onIn);
  var onOutHandler = useVariable(onOut);
  var onChange = useCallback(function (isIn) {
    if (isIn) {
      onInHandler.current == null ? void 0 : onInHandler.current();
    } else {
      onOutHandler.current == null ? void 0 : onOutHandler.current();
    }
  }, []);

  var _useInput = useInput(value, defaultValue, onChange),
      isIn = _useInput[0],
      setIn = _useInput[1];

  var handleOut = useCallback(function () {
    setIn(false);
  }, []);
  var handleIn = useCallback(function () {
    setIn(true);
  }, []);
  return [isIn, handleIn, handleOut];
};